import React, {ReactElement} from "react";

import {Spinner} from "../spinner";

import styles from "./loading-page.module.scss";

const LoadingPage = (): ReactElement => {
	return (
		<div className={styles.page}>
			<div className={styles.container}>
				<Spinner/>
			</div>
		</div>
	);
};

export {LoadingPage};
